import {
    SingleVoucherRow,
    SingleVoucherText,
    SingleVoucherWrapper,
    SingleVoucherIconButton,
} from 'components/shared/SingleCustomVoucher/styles'
import { ReactNode } from 'react'
import Icon from 'components/shared/Icon'
import Box from 'components/shared/Box'

interface SingleCustomVoucherProps {
    children: ReactNode
}

const Heading = ({ voucherName }: { voucherName: string }) => (
    <SingleVoucherText variant="heading2" pb={[0, 16]}>
        {voucherName}
    </SingleVoucherText>
)

const Button = ({
    children,
    onClick,
    testIdPrefix,
}: {
    children: ReactNode
    onClick: () => void
    testIdPrefix?: string
}) => (
    <SingleVoucherIconButton
        onClick={onClick}
        data-testid={testIdPrefix ? `${testIdPrefix}-button-edit` : undefined}
    >
        {children}
        <Icon variant="pencil" />
    </SingleVoucherIconButton>
)

const Row = ({
    children,
    value,
    isBorder = true,
}: {
    children: ReactNode
    value: string | number | (string | number)[]
    isBorder?: boolean
}) => (
    <SingleVoucherRow
        pt={16}
        pb={isBorder ? 16 : 0}
        pl={0}
        pr={0}
        direction="row"
        justify="space-between"
        isFullWidth
        isBorder={isBorder}
    >
        <SingleVoucherText variant="bodyLarge" color="grayscale_700">
            {children}
        </SingleVoucherText>

        {Array.isArray(value) ? (
            <Box align="flex-end" isFullWidth>
                {value.map((content, index) => (
                    <SingleVoucherText
                        key={index}
                        variant="bodyLarge"
                        color="grayscale_900"
                        isEnd
                    >
                        {content.toString().trim()}
                    </SingleVoucherText>
                ))}
            </Box>
        ) : (
            <SingleVoucherText variant="bodyLarge" color="grayscale_900" isEnd>
                {value.toString().trim()}
            </SingleVoucherText>
        )}
    </SingleVoucherRow>
)

const SingleCustomVoucher = ({ children }: SingleCustomVoucherProps) => (
    <SingleVoucherWrapper
        pb={[24, 56]}
        pt={[24, 56]}
        pl={[16, 80]}
        pr={[16, 80]}
    >
        {children}
    </SingleVoucherWrapper>
)

SingleCustomVoucher.displayName = 'SingleVoucher'
SingleCustomVoucher.Heading = Heading
SingleCustomVoucher.Row = Row
SingleCustomVoucher.Button = Button

export default SingleCustomVoucher
